// Client-side reasons shown in the "Criar parecer" tooltip to explain why the action is
// disabled. These gate the action before any request is made, so they can't come from the
// backend response — the backend returns its own `user_message` (see KycParecerService) only
// when a create actually reaches it (defense in depth). Keep the two surfaces in sync.
export const PARECER_BLOCKED_REASONS = {
  deletedPolicy: 'Não é possível iniciar um parecer para relatórios de uma política excluída.',
  reportHasParecer: 'Já existe um parecer para este relatório. Gere um novo relatório para reavaliar a entidade.',
  // Shown inside the parecer wizard (not in the "Criar parecer" tooltip) when the policy defines no
  // relationship types AND the account has no active one (the parecer falls back to the
  // account's relationship types otherwise).
  accountWithoutRelationshipTypes:
    'A conta não possui tipos de relacionamento ativos. '
    + 'Cadastre ao menos um tipo de relacionamento para criar um parecer.',
} as const;
